export const removeDataTags = () => {
    const elementsWithDataTags = document.querySelectorAll('[data-tags="page-tags"]');
    elementsWithDataTags.forEach(element => {
        element.parentNode.removeChild(element);
    });
};

export const appendTagsToElement = (htmlString, tagElement, position, dataAttributeValue) => {
    const tempContainer = document.createElement('div');
    tempContainer.innerHTML = htmlString;

    const children = Array.from(tempContainer.childNodes);

    children.forEach(child => {
        if (child.nodeType !== Node.ELEMENT_NODE) return;

        // Handle <script> tags
        if (child.tagName === 'SCRIPT') {
            const script = document.createElement('script');
            // копируем все атрибуты из исходного узла
            for (const { name, value } of child.attributes) {
                script.setAttribute(name, value);
            }

            // переносим содержимое (если есть inline JS)
            if (child.textContent) {
                script.text = child.textContent;
            }

            if (position === 'top') {
                tagElement.insertBefore(script, tagElement.firstChild);
            } else {
                tagElement.appendChild(script);
            }
        }

        // Handle <noscript> tags
        else if (child.tagName === 'NOSCRIPT') {
            const noscript = document.createElement('noscript');
            noscript.innerHTML = child.innerHTML;

            if (dataAttributeValue) {
                noscript.setAttribute('data-tags', dataAttributeValue);
            }

            if (position === 'top') {
                tagElement.insertBefore(noscript, tagElement.firstChild);
            } else {
                tagElement.appendChild(noscript);
            }
        }

        // Handle all other tags
        else {
            const clonedChild = child.cloneNode(true);

            if (dataAttributeValue) {
                clonedChild.setAttribute('data-tags', dataAttributeValue);
            }

            if (position === 'top') {
                tagElement.insertBefore(clonedChild, tagElement.firstChild);
            } else {
                tagElement.appendChild(clonedChild);
            }
        }
    });
};

export const pageTags = (json) => {
    removeDataTags();
    const headTagString = json.headTags;
    const bodyTopTagString = json.bodyTopTags;
    const bodyBottomTagString = json.bodyBottomTags;

    if (headTagString) {
        appendTagsToElement(headTagString, document.head, null, 'page-tags');
    }
    if (bodyTopTagString) {
        appendTagsToElement(bodyTopTagString, document.body, 'top', 'page-tags');
    }
    if (bodyBottomTagString) {
        appendTagsToElement(bodyBottomTagString, document.body, null, 'page-tags');
    }
};

export const projectTags = (json) => {
    const projectTags = document.querySelectorAll('[data-tags="project-tag"]');
    if (!projectTags.length) {
        json.map(item => {
            if (item.positionType === 0) {
                const headTagStringAll = item.body;
                appendTagsToElement(headTagStringAll, document.head, null, 'project-tag');
            } else {
                const bodyTagStringAll = item.body;
                appendTagsToElement(bodyTagStringAll, document.body, null, 'project-tag');
            }
        });
    }
};

export const pageMetaTag = (json) => {
    const titleTag = document.querySelector('title');
    if (json?.title && titleTag) {
        titleTag.textContent = json.title;
    }

    const descriptionMetaTag = document.querySelector('meta[name="description"]');
    if (json?.description && descriptionMetaTag) {
        descriptionMetaTag.setAttribute('content', json.description);
    }

    const canonicalUrlTag = document.querySelector('link[rel="canonical"]');
    if (json?.canonicalUrl && canonicalUrlTag) {
        canonicalUrlTag.setAttribute('href', json.canonicalUrl);
    }

    const keywordsMetaTag = document.querySelector('meta[name="keywords"]');
    if (json?.keywords && keywordsMetaTag) {
        keywordsMetaTag.setAttribute('content', json.keywords);
    }
};
